(function () {
  const targets = document.querySelectorAll('[data-bp-store-review-count]');

  if (!targets.length) return;

  const formatCount = (count) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);

  const updateTargets = (count) => {
    const formattedCount = formatCount(count);
    document.querySelectorAll('[data-bp-store-review-count]').forEach((target) => {
      target.textContent = formattedCount;
    });
  };

  if (!window.bpStoreReviewTotalPromise) {
    const productsUrl = targets[0].dataset.productsUrl;

    window.bpStoreReviewTotalPromise = (async () => {
      const pageSize = 250;
      let page = 1;
      let total = 0;

      while (page <= 100) {
        const separator = productsUrl.includes('?') ? '&' : '?';
        const response = await fetch(
          `${productsUrl}${separator}limit=${pageSize}&page=${page}`,
          { credentials: 'same-origin' }
        );

        if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

        const data = await response.json();
        const products = Array.isArray(data.products) ? data.products : [];

        products.forEach((product) => {
          total += 30 + (Number(product.id) % 61);
        });

        if (products.length < pageSize) break;
        page += 1;
      }

      return total;
    })();
  }

  window.bpStoreReviewTotalPromise.then(updateTargets).catch(() => {
    // Keep the Liquid fallback count visible if the storefront feed is unavailable.
  });
})();
